module.exports = __webpack_public_path__ + "img/9788992060967.2389ae0e.jpg";